<template>
  <form class="ti-form" id="form" @submit.prevent>
    <div
      class="ti-form__loader"
      v-if="!form || !form.sections || form.sections.length == 0"
    >
      <wb-spinner theme="light" />
    </div>

    <template v-if="form && form.sections">
      <div
        class="ti-form__section"
        :class="{ ['ti-form__section' + section.cssClass]: section.cssClass }"
        v-for="section in form.sections"
      >
        <div
          class="ti-form__section-header"
          v-if="section.headline && section.copy"
        >
          <wb-icon :name="$t(section.icon)" v-if="section.icon"></wb-icon>
          <div class="ti-form__section-header-content">
            <p
              class="ti-form__section-header-copy"
              v-if="section.copy"
              :class="{
                'ti-form__section-header-copy--coupled-with-heading':
                  section.headline,
              }"
            >
              {{ $t(section.copy) }}
            </p>
          </div>
        </div>
        <template
          v-for="formElement in section.elements"
          :key="formElement.key"
        >
          <FormElementComponent
            v-show="formElement.options.display !== false"
            :element="formElement"
            @updateFormElement="(e) => updateFormElement(formElement, e)"
            @modalClosed="modalClosed"
          />
        </template>
        <TooltipComponent
          class="ti-form__section-tooltip"
          v-if="section.tooltip && section.tooltip.label"
          :text="section.tooltip.label"
          @getStep="getStep"
        />
      </div>
    </template>
  </form>
</template>
<script lang="ts" setup>
import { Form, FormElement, Modal } from '@tradein/api';
import { watch } from 'vue';
import { checkForm, getFormChanges } from './utils';

import TooltipComponent from '../tooltip/tooltip.vue';
import FormElementComponent from '../form-element/form-element.vue';

const props = defineProps<{
  form: Form;
  updating: boolean;
}>();
const emit = defineEmits(['formChanged', 'modalClosed', 'getStep']);

const updateFormElement = (
  element: FormElement,
  updatedElement: FormElement,
): void => {
  getFormChanges(props.form, element, updatedElement);
  emit('formChanged', props.form);
};

const modalClosed = (modal: Modal): void => {
  emit('modalClosed', modal);
};

const getStep = (stepId: string): void => {
  emit('getStep', stepId);
};

watch(
  () => props.form,
  () => {
    checkForm(props.form);
  },
  { immediate: true, deep: true },
);
</script>
<style lang="scss" src="./form.scss"></style>
